import rasko from "../../assets/img/rasko.png";
import quai from "../../assets/img/quai.png";
import eye from "../../assets/img/eye.png";
import comics from "../../assets/img/comics.png";
import { useEffect, useRef } from "react";
import styles from "./FirstScreen.module.css";
import { createBrowserHistory } from "history";

export const MainImgMobile = () => {
  const history = createBrowserHistory();
  return (
    <svg
      width='480'
      height='685'
      viewBox='0 0 480 685'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <ellipse
        cx='239.376'
        cy='265.858'
        rx='158.858'
        ry='158.849'
        transform='rotate(90 239.376 265.858)'
        fill='#F4F7FD'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M480 684.5L480 265L420.231 265C417.332 362.269 337.574 440.231 239.607 440.231C141.641 440.231 61.8832 362.269 58.9842 265L0 265L1.22279e-05 684.5L480 684.5Z'
        fill='#F4F7FD'
      />
      <g filter='url(#filter0_d_1188_1666)'>
        <path
          d='M355 230L228.394 55.9413C226.136 52.8367 222.529 51 218.69 51H56'
          stroke='white'
          stroke-width='2'
          stroke-dasharray='4 4'
        />
        <animate
          attributeName='stroke-dashoffset'
          dur='1s'
          repeatCount='indefinite'
          begin='0ms'
          values='0; 16;'
        />
      </g>
      <g filter='url(#filter1_d_1188_1666)'>
        <circle cx='48.3819' cy='51.3819' r='16.3819' fill='#5A70FF' />
      </g>
      <circle cx='48.2514' cy='51.2514' r='9.02879' fill='white'>
        <animate
          attributeName='r'
          repeatCount='indefinite'
          begin='1ms'
          values='5;9;5;'
          dur='3s'
        />
      </circle>
      <line
        x1='91.6464'
        y1='428.646'
        x2='193.646'
        y2='326.646'
        stroke='#005BBC'
      />
      <circle cx='71' cy='481' r='56.5' stroke='#005BBC' />
      <line
        x1='384.646'
        y1='429.354'
        x2='282.646'
        y2='327.354'
        stroke='#005BBC'
      />
      <circle cx='407' cy='481' r='56.5' stroke='#005BBC' />
      <circle cx='170' cy='570' r='56.5' stroke='#005BBC' />
      <line
        x1='179.517'
        y1='514.205'
        x2='216.852'
        y2='374.871'
        stroke='#005BBC'
      />
      <circle cx='308' cy='570' r='56.5' stroke='#005BBC' />
      <line
        x1='297.852'
        y1='514.464'
        x2='260.517'
        y2='375.129'
        stroke='#005BBC'
      />
      <g filter='url(#filter2_di_1188_1666)'>
        <circle cx='238.5' cy='265.5' r='146.5' fill='#F4F7FD' />
      </g>
      <g filter='url(#filter3_di_1188_1666)'>
        <circle cx='238.5' cy='265.5' r='101.5' fill='#F4F7FD' />
      </g>
      <path
        d='M293.613 330H239C203.038 330 174 300.851 174 265C174 247.019 181.259 230.825 193.098 218.986C204.825 207.259 221.019 200 239 200C256.981 200 273.287 207.259 284.902 218.986C290.821 224.905 295.512 231.942 298.863 239.759C302.213 247.466 304 256.065 304 265.112C304 279.407 299.421 292.586 291.491 303.308C289.816 305.765 287.806 307.998 285.684 310.12L266.921 291.134C273.399 284.321 277.308 275.163 277.308 265C277.308 254.39 273.064 244.897 266.139 237.973C259.215 231.048 249.498 226.804 239 226.804C228.502 226.804 218.897 231.048 211.973 237.973C205.048 244.897 200.804 254.39 200.804 265C200.804 286.108 217.892 303.196 239 303.196V275.498L293.613 330Z'
        fill='url(#paint0_linear_1188_1666)'
      />
      <defs>
        <filter
          id='filter0_d_1188_1666'
          x='51'
          y='45'
          width='309.809'
          height='190.588'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='2.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1188_1666'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1188_1666'
            result='shape'
          />
        </filter>
        <filter
          id='filter1_d_1188_1666'
          x='-3'
          y='0'
          width='102.764'
          height='102.764'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='17.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 0.981667 0 0 0 0 0.981667 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1188_1666'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1188_1666'
            result='shape'
          />
        </filter>
        <filter
          id='filter2_di_1188_1666'
          x='69'
          y='96'
          width='339'
          height='339'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='11.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.508333 0 0 0 0 0.499014 0 0 0 0 0.499014 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1188_1666'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1188_1666'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-6' dy='12' />
          <feGaussianBlur stdDeviation='6' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_1188_1666'
          />
        </filter>
        <filter
          id='filter3_di_1188_1666'
          x='114'
          y='141'
          width='249'
          height='249'
          filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'>
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset />
          <feGaussianBlur stdDeviation='11.5' />
          <feComposite in2='hardAlpha' operator='out' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.508333 0 0 0 0 0.499014 0 0 0 0 0.499014 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1188_1666'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_1188_1666'
            result='shape'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-5' dy='9' />
          <feGaussianBlur stdDeviation='3' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='shape'
            result='effect2_innerShadow_1188_1666'
          />
        </filter>
        <linearGradient
          id='paint0_linear_1188_1666'
          x1='206.207'
          y1='331.111'
          x2='296.3'
          y2='190.342'
          gradientUnits='userSpaceOnUse'>
          <stop stop-color='#74EAE8' />
          <stop offset='1' stop-color='#0394E8' />
        </linearGradient>
      </defs>
      <image
        x='20'
        y='433'
        className={styles.image_circle}
        width='100px'
        height='100px'
        href={rasko}
        xlinkHref={rasko}
        onClick={() => {
          history.push("https://asko.finance/");
        }}></image>
      <image
        x='119'
        y='522'
        className={styles.image_circle}
        width='100px'
        height='100px'
        href={eye}
        xlinkHref={eye}
        onClick={() => {
          history.push("https://mediaeyenft.com/");
        }}></image>
      <image
        x='257'
        y='522'
        className={styles.image_circle}
        width='100px'
        height='100px'
        href={quai}
        xlinkHref={quai}
        onClick={() => {
          history.push("https://quai-invest.net/");
        }}></image>
      <image
        x='356'
        y='433'
        className={styles.image_circle}
        width='100px'
        height='100px'
        href={comics}
        xlinkHref={comics}></image>
    </svg>
  );
};
